import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { Container, Loader, Table, Tbody, Pagination, Info } from './styles';
import { GetDataSecondBilletRequest } from '~/store/modules/properties/actions';
import { store } from '~/store';

import api from '~/services/apiBearer';

export default function FinancialSummary(props) {
  const dispatch = useDispatch();
  const [financialSummmary, setFinancialSummary] = useState(
    store.getState().properties.data.data
  );

  const [topic, setTopic] = useState('');
  const [reference, setReference] = useState('');
  const [contractId, setContractId] = useState('');
  const [address, setAddress] = useState('');

  const [page, setPage] = useState(1);
  const [totalPages] = useState(10);
  const [showNextPageButton, setShowNextPageButton] = useState(true);
  const [loader, setLoader] = useState(
    useSelector(state => state.properties.loading)
  );

  useEffect(() => {
    if (props && props.location && props.location.state) {
      const {
        sAddress,
        sContractId,
        sReference,
        sTopic,
      } = props.location.state;
      setAddress(sAddress);
      setContractId(sContractId);
      setReference(sReference);
      setTopic(sTopic);
    }
  }, [props]);

  useEffect(() => {
    const { token } = store.getState().auth;
    dispatch(GetDataSecondBilletRequest(token, contractId, page, totalPages));
  }, [contractId, dispatch, page, totalPages]);

  useEffect(() => {
    setLoader(true);

    const url = `api/v1/WSBoleto?Contrato=${contractId}&pagina=${page}&tamanhoPagina=${totalPages}`;
    api
      .get(url)
      .then(
        response => {
          const { sucesso: success, conteudo } = response.data;

          if (success) {
            setFinancialSummary(conteudo);

            if (conteudo.length < 10) setShowNextPageButton(false);
            else setShowNextPageButton(true);
          }
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }, [contractId, page, totalPages]);

  // eslint-disable-next-line no-unused-vars
  function handleToCopy() {
    const text = document.querySelector('#barcodeNumber');
    text.select();
    try {
      const ok = document.execCommand('copy');
      if (ok) {
        toast.success('Número de boleto copiado para a área de transferência');
      }
    } catch (e) {
      toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    }
  }
  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />
      <Info>
        <h1>{topic}</h1>

        <div>
          <span>Ref.: {reference}</span>
          <span>Contrato: {contractId}</span>
          <span>{address}</span>
        </div>
      </Info>
      {financialSummmary && financialSummmary.length ? (
        <Table>
          <thead>
            <tr>
              <td>Vencimento</td>
              <td>Nº do boleto</td>
              <td>Aluguel</td>
              <td>Abatimento</td>
              <td>Taxas</td>
              <td>Situação</td>
            </tr>
          </thead>
          {financialSummmary && financialSummmary.length ? (
            financialSummmary.map(second => {
              const pago = second.status === 'Pago';
              return (
                <Tbody
                  key={second.codigoRecibo}
                  statusColor={pago ? '#66CC00' : '#CC0000'}
                >
                  <tr key={second.codigoRecibo}>
                    <td>
                      {second.vencimento
                        ? format(new Date(second.vencimento), 'dd/MM/yyyy')
                        : second.vencimento}
                    </td>
                    <td>
                      <input
                        id="barcodeNumber"
                        // onClick={handleToCopy}
                        defaultValue={
                          second.codigoBarras
                            ? second.codigoBarras
                            : '000 0000 0000 0000 0'
                        }
                      />
                    </td>
                    <td>R$ {second.valorAluguel}</td>
                    <td>R$ {second.valorBonificacao}</td>
                    <td>R$ {second.valorTaxa}</td>
                    <td className="status">{second.status}</td>
                  </tr>
                </Tbody>
              );
            })
          ) : (
            <div>Você ainda não possui dados de resumo financeiro.</div>
          )}
        </Table>
      ) : (
        <h2>Você ainda não possui dados de resumo financeiro</h2>
      )}
      {financialSummmary && financialSummmary.length ? (
        <Pagination>
          <div>
            {page > 1 ? (
              <FaArrowAltCircleLeft
                size={22}
                onClick={() => setPage(page - 1)}
              />
            ) : (
              <FaArrowAltCircleLeft
                size={22}
                color="#bbb"
                style={{ cursor: 'initial' }}
              />
            )}
            {`Visualizando página ${page}`}
            {showNextPageButton ? (
              <FaArrowAltCircleRight
                size={22}
                onClick={() => setPage(page + 1)}
              />
            ) : (
              <FaArrowAltCircleRight
                size={22}
                color="#bbb"
                style={{ cursor: 'initial' }}
              />
            )}
          </div>
        </Pagination>
      ) : (
        ''
      )}
    </Container>
  );
}

FinancialSummary.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
